import { useTranslation } from 'react-i18next';
import useRouteBasedStepperLayout from 'components/Stepper/RouteBasedStepper/useRouteBasedStepperLayout';
import { useCreateProposalState } from 'datasource/ProposalManagement/CreateProposalManager/useCreateProposalState';
import { useMemo } from 'react';
import useCreateNewProposalFlow from './useCreateNewProposalFlow';

export const useCreateNewProposalLayout = () => {
    const { t } = useTranslation();
    const {
        currentPortfolioSelector, mainOwner, jaClient, selectedProductTypeSelector,
    } = useCreateProposalState();
    const { stepsBasedOnState } = useCreateNewProposalFlow();

    const footerAdditionalInfo = useMemo(() => [
        {
            label: 'portfolio.createNewPortfolio.clientName',
            values: [mainOwner?.name ?? '-', ...[jaClient?.name]],
        },
        {
            label: 'portfolio.createNewPortfolio.clientAge',
            values: [mainOwner?.age?.toString() ?? '-', ...[jaClient?.age?.toString()]],
        },
        {
            label: 'portfolio.createNewPortfolio.productOffer',
            values: [selectedProductTypeSelector ?? '-'],
        },
    ], [mainOwner, jaClient, selectedProductTypeSelector]);

    const {
        stepper: {
            steps: currentProcessSteps,
            title,
            currentStepNumber,
        },
        contentTitle,
        contentClassName,
        isStepperEnabled,
        isFooterSimplified,
        onContinue,
        onBack,
        continueDisabled,
        isContinueLoading,
        backDisabled,
        hideStepperButtons,
        productType,
    } = useRouteBasedStepperLayout({
        title: t('Layout.CreateNewProposal.Sidebar.Title'),
        productType: currentPortfolioSelector?.Name,
        stepsBasedOnState,
    });

    return {
        footerAdditionalInfo,
        stepper: {
            steps: currentProcessSteps,
            title,
            currentStepNumber,
        },
        onBack,
        onContinue,
        continueDisabled,
        backDisabled,
        inProgress: isContinueLoading,
        isStepperEnabled,
        isFooterSimplified,
        contentTitle,
        contentClassName,
        hideStepperButtons,
        productType,
        startDate: null,
        minStartDate: null,
        allowJumpStep: false,
    };
};
